import React from 'react';
import { MDText } from 'i18n-react';

import { InfoIcon } from '@motorway/mw-highway-code';

import cypressIds from 'Components/cypress_ids.json';
import { applyCypressData } from 'Utilities/helpers';

import vehicleFeaturesSectionTexts from '../VehicleFeaturesSection.texts';

import styles from './FeaturesEmptyState.module.scss';

const LocalT = new MDText(vehicleFeaturesSectionTexts.empty);

export const FeaturesEmptyState: React.FC = () => (
	<div className={styles.container} {...applyCypressData(cypressIds.containers.emptyFeatures)}>
		<InfoIcon filled={false} />
		<p className={styles.message}>{LocalT.translate('title')}</p>
	</div>
);
